import { render, staticRenderFns } from "./OptionSector.vue?vue&type=template&id=18115962&scoped=true&"
import script from "./OptionSector.vue?vue&type=script&lang=ts&"
export * from "./OptionSector.vue?vue&type=script&lang=ts&"
import style0 from "./OptionSector.vue?vue&type=style&index=0&id=18115962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18115962",
  null
  
)

export default component.exports